var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-yoga-layout",
    {
      attrs: {
        "width-auto": "1",
        "height-auto": "1",
        padding: "0",
        "flex-direction": "column",
        geometry: "primitive: plane;",
        material: "visible: false",
      },
    },
    [
      _c("a-video", {
        attrs: {
          "yoga-layout-item": "margin: 0.05; marginEdge: bottom",
          src: "#video-" + _vm.block.field_values.video.id,
          width: _vm.videoWidth,
          height: _vm.videoHeight,
        },
      }),
      _vm._v(" "),
      _c("a-html", { attrs: { autoEnable: "false" } }, [
        _c("div", { staticClass: "vr" }, [
          _c("div", {
            domProps: { innerHTML: _vm._s(_vm.block.field_values.html) },
          }),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }